import { Component, HostListener, Input, OnInit } from '@angular/core';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { DefaultLayoutDirective } from '../../../../flex-layout/custom-layout';
import { DefaultFlexDirective } from '../../../../flex-layout/flex';
import { MatIconButton } from '@angular/material/button';
import { DefaultLayoutAlignDirective } from '../../../../flex-layout/custom-layout-align';
import { environment } from '../../../../../environments/environment';
import { Router } from '@angular/router';
import { CartService } from '../../../../services/cart.service';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from '../../../../services/user.service';
import { CalsoftService } from '../../../../services/calsoft.service';
import { Constant } from '../../../../../constants/constant';
import { CommonSignInComponent } from '../../../../shared/common-sign-in/common-sign-in.component';
import { CategoryService } from '../../../../services/category.service';
import { Location } from '@angular/common';
import { SideBarMenuPopupComponent } from '../../menu/menu/side-bar-menu/side-bar-menu-popup/side-bar-menu-popup.component';

@Component({
  selector: 'calsoft-mobile-header9',
  imports: [MatToolbar, MatToolbarRow, DefaultLayoutDirective, DefaultFlexDirective, MatIconButton, DefaultLayoutAlignDirective],
  templateUrl: './mobile-header9.component.html',
  styleUrl: './mobile-header9.component.scss'
})
export class MobileHeader9Component implements OnInit {
  
  @Input() item: any;
  @Input() url: any;
  @Input() userLoggedIn: any;
  @Input() color: any;
  categoryArray: any = [];
  referer: string |any;

  //logoPositionMobile:boolean = false;
  mobileHeaderHeight: any;
  mobileHeaderLogoGap: any;
  layout: any = 0;
  headerIconColour: any;
  @Input() data: any;


  public serverPath = environment.commonImageApi + "logo/";

  public serverPath3 = environment.commonImageApi + "mobileImage/";

  mobileLogoSrc: any;

  mobileLogoEnable: any = 0;
  disableCartIconInHeader: any = 0;

  disableLoginHeader: any = 0;
  disableWishlistHeader: any = 0;
  contentDiv: boolean;
  // Add these variables to your component class
  lastScrollPosition = 0;
  showMobileHeader = true;
  mobileScrollThreshold = 50; // Adjust as needed
  hideThreshold = 100; // Hide when scrolled beyond this point
  lastTouchY: number |any;

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    // Calculate scroll direction
    const scrollDelta = currentScrollPosition - this.lastScrollPosition;
    const scrollingDown = scrollDelta > 0;
    const scrollingUp = scrollDelta < 0;

    // Always show at top of page
    if (currentScrollPosition <= 50) {
      this.showMobileHeader = true;
    }
    // Show when scrolling up significantly
    else if (scrollingUp && Math.abs(scrollDelta) > 10) {
      this.showMobileHeader = true;
    }
    // Hide when scrolling down past threshold
    else if (scrollingDown && currentScrollPosition > this.hideThreshold) {
      this.showMobileHeader = false;
    }

    this.lastScrollPosition = currentScrollPosition;
  }
  constructor(
    private router: Router,
    public cartServices: CartService,
    private dialog: MatDialog,
    private userService: UserService,
    private categoryService: CategoryService,
    private location: Location,
    public calsoftService: CalsoftService,) {
    this.contentDiv = false;
  }

  display: boolean=false;
  ngOnInit(): void {

    if (window.innerWidth < 1281) {
      this.display = false;
    } else {
      this.display = true
    }

    this.getCategories();
    this.referer = Constant.REFERER;

    if (this.data != undefined) {
      if (this.data['logoPositionMobile'] != undefined) {
        this.layout = this.data['logoPositionMobile'];
      }

      if (this.data['headerIconColour'] != undefined) {
        this.headerIconColour = this.data['headerIconColour'];
      }

      if (this.data['mobileLogoSrc'] != undefined) {
        this.mobileLogoSrc = this.data['mobileLogoSrc'];
      }

      if (this.data['mobileLogoEnable'] != undefined) {
        this.mobileLogoEnable = this.data['mobileLogoEnable'];
      }

      if (this.data['mobileHeaderHeight'] != undefined) {
        this.mobileHeaderHeight = this.data['mobileHeaderHeight'];
      }


      if (this.data['mobileHeaderLogoGap'] != undefined) {
        this.mobileHeaderLogoGap = this.data['mobileHeaderLogoGap'];
      }


      if (this.data['disableCartIconInHeader'] != undefined) {
        this.disableCartIconInHeader = this.data['disableCartIconInHeader'];
      }


      if (this.data['disableLoginHeader'] != undefined) {
        this.disableLoginHeader = this.data['disableLoginHeader'];
      }

      if (this.data['disableWishlistHeader'] != undefined) {
        this.disableWishlistHeader = this.data['disableWishlistHeader'];
      }



    }



    this.userLogged();
    const currentPosition = window.pageYOffset || document.documentElement.scrollTop;
    this.showMobileHeader = currentPosition <= this.hideThreshold;
    this.lastScrollPosition = currentPosition;

  }
  @HostListener('window:touchstart', ['$event'])
  onTouchStart(event: TouchEvent) {
    this.lastTouchY = event.touches[0].clientY;
  }

  @HostListener('window:touchmove', ['$event'])
  onTouchMove(event: TouchEvent) {
    const currentY = event.touches[0].clientY;
    const deltaY = currentY - this.lastTouchY;

    if (Math.abs(deltaY) > 10) {
      if (deltaY > 0) { // Swiping down
        this.showMobileHeader = true;
      } else { // Swiping up
        if (window.pageYOffset > this.hideThreshold) {
          this.showMobileHeader = false;
        }
      }
    }

    this.lastTouchY = currentY;
  }
  page1: any;
  public toggleSidebarz() {
    // this.calsoftService.sidenavOpen = !this.calsoftService.sidenavOpen;
    this.contentDiv = !this.contentDiv;
  }
  gotoHome() {
    if (this.router.url != '/home') {
      this.router.navigate(['/']);
    }
  }

  cart() {
    let basicAuthHeaderString = this.userService.getAuthenticatedToken();
    let username = this.userService.getAuthenticatedUser();

    if (basicAuthHeaderString && username) {
      this.router.navigate(['/cart'])

    }
    else {
      this.page1 = "cart";
      this.loginModel();

      // this.router.navigate(['/cart'])

    }

  }


  loginModel() {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(CommonSignInComponent, {
        width: '790px',
        data: { page: this.page1, }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        this.ngOnInit();


      });

    }
    else {
      let dialogRef = this.dialog.open(CommonSignInComponent, {
        minWidth: '100vw', height: '100vh',
        data: { page: this.page1, }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        this.ngOnInit();


      });
    }

  }
  back() {

    if (this.router.url.includes('/order/')) {
      this.router.navigate(['/orders'])
    } else {
      // this.router.navigate(['/'])
      this.location.back();
    }

  }


  SignIn() {
    // this.router.navigate(['/sign-in']);
    this.loginModel();
  }


  userLogged() {

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    let basicAuthHeaderString = this.userService.getAuthenticatedToken();
    let username = this.userService.getAuthenticatedUser();

    if (basicAuthHeaderString && username) {

      this.userLoggedIn = true;
      this.cartServices.getCount();

    }
    else {

      this.userLoggedIn = false;
    }
  }


  navigateTo(route: string) {
    this.router.navigate([route]);
  }


  getCategories() {
    this.categoryService.categoryList().subscribe(
      (result:any) => {
        this.categoryArray = result['data'];
      },
      error => {
      }
    )
  }

  toggleSidebar() {
    let dialogRef = this.dialog.open(SideBarMenuPopupComponent, {
      minWidth: '100vw', height: '100vh',
      backdropClass: 'no-backdrop',
      panelClass: 'custom-dialog',
      data: { data: this.categoryArray, datas: this.data },
    });

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

}

